import type { ReactNode } from 'react';

export type QuickLink = {
  href: string;
  title: string;
  iconLarge: ReactNode;
  iconMedium: ReactNode;
  iconSmall: ReactNode;
  isInternalLink: boolean;
  iconMediumDisabled?: ReactNode;
  iconSmallDisabled?: ReactNode;
};

export enum QuickLinkName {
  BUYER_AGREEMENT = 'BUYER_AGREEMENT',
  CREATE_LEASE = 'CREATE_LEASE',
  CREATE_LISTING = 'CREATE_LISTING',
  CREATE_OFFER = 'CREATE_OFFER',
  FINANCIAL_REPORT = 'FINANCIAL_REPORT',
  GROWTH_HUB = 'GROWTH_HUB',
  GROWTH_REPORT = 'GROWTH_REPORT',
  PLATFORM_FEE_REPORT = 'PLATFORM_FEE_REPORT',
  RECEIVE_REFERRAL = 'RECEIVE_REFERRAL',
  START_REFERRAL = 'START_REFERRAL',
  PRICING_PLAN_PROGRESS_REPORT = 'PRICING_PLAN_PROGRESS_REPORT',
  USER_TEMPLATES = 'USER_TEMPLATES',
  CANVA = 'CANVA',
}
